import { Button, useDisclosure } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../shared/stores/RootStore";
import { useMemo, useState } from "react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  CutIcon,
} from "../../../shared/views/icons";
import { HlaWay } from "../../models/HlaWay";
import { CustomMenu } from "../../../shared/views/CustomMenu";
import { toast } from "../../../shared/views/CustomToaster";
import { CutHlaModal } from "./cut/CutHlaModal";

const MergeIntoMenuBase: React.FC = () => {
  const { hlaStore } = useStores();
  const hlaWay = hlaStore.getSelected()!;
  const cutHlaModal = useDisclosure();
  const [submitting, setSubmitting] = useState(false);

  const mergeIntoOptions: TargetOption[] = useMemo(() => {
    const previous = hlaStore.adjacentToSelected.previous.map((w) => ({
      hlaWay: w,
      isNext: false,
    }));

    const next = hlaStore.adjacentToSelected.next.map((w) => ({
      hlaWay: w,
      isNext: true,
    }));

    return [...previous, ...next];

    // eslint-disable-next-line
  }, [hlaWay]);

  const onSuccess = () => {
    toast("success", "Segments merged");
  };
  const onError = () => {
    toast("error", "Failed to merge segments");
  };

  return (
    <>
      <CustomMenu
        items={[
          {
            text: "Cut...",
            key: "cut",
            description: "Split segment in two",
            icon: <CutIcon />,
            onClick: cutHlaModal.onOpen,
          },
          ...mergeIntoOptions.map((option) => {
            return {
              text: `Merge into ${option.hlaWay.name ?? "Unknown street"}`,
              key: option.hlaWay.id,
              description: option.isNext ? "Next segment" : "Previous segment",
              icon: option.isNext ? <ArrowRightIcon /> : <ArrowLeftIcon />,
              onClick: () => {
                setSubmitting(true);
                hlaStore
                  .mergeInto(hlaWay.id, { targetHlaWayId: option.hlaWay.id })
                  .then(onSuccess)
                  .catch(onError)
                  .finally(() => setSubmitting(false));
              },
            };
          }),
        ]}
      >
        <Button
          variant={"plain"}
          size={"sm"}
          colorPalette={"primary"}
          fontSize={"sm"}
          loading={submitting}
        >
          More...
        </Button>
      </CustomMenu>

      {cutHlaModal.open && <CutHlaModal onClose={cutHlaModal.onClose} />}
    </>
  );
};

export const MergeIntoMenu = observer(MergeIntoMenuBase);

interface TargetOption {
  hlaWay: HlaWay;
  isNext: boolean;
}
